import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import * as React from 'react';

const QUERIES_MEMORY = 10;

export interface AISearchQueryState {
    query: string;
    previousQueries: string[];
}

const aiSearchQueryAtom = atomWithStorage<AISearchQueryState>(
    'aiSearchQuery',
    {
        query: '',
        previousQueries: [],
    },
    undefined,
    { getOnInit: true }
);

/**
 * Hook to manage the state of a user submitted query, while storing the N previous queries.
 */
export function useAISearchQuery(): [AISearchQueryState, (newQuery: string) => void] {
    const [state, setState] = useAtom(aiSearchQueryAtom);

    const submitQuery = React.useCallback(
        (query: string) => {
            setState((prev) => {
                if (!prev) {
                    return {
                        query,
                        previousQueries: [],
                    };
                }

                return {
                    query,
                    previousQueries: [
                        ...prev.previousQueries.filter((q) => q !== query && q !== prev.query),
                        ...(prev.query ? [prev.query] : []),
                    ].slice(-QUERIES_MEMORY),
                };
            });
        },
        [setState]
    );

    return [state, submitQuery];
}
